/**
 * レベル毎に出力する質問数を設定
 */
export default [
  {
    level: 1,
    output: 10,
  },
];
